export default "__VITE_ASSET__ptbIenXM__"